// permission.service.ts
import { Injectable } from '@angular/core';

export type PermissionAction = 'create' | 'read' | 'update' | 'delete';

/** API menu payload may omit `list_screens` or return a non-array on error responses. */
export function getMenuScreenList(menuObj: unknown): any[] {
  const list = (menuObj as { list_screens?: unknown } | null | undefined)?.list_screens;
  return Array.isArray(list) ? list : [];
}

export function getMenuScreenIds(menuObj: unknown): number[] {
  return getMenuScreenList(menuObj)
    .map((screen: { screen_id?: number }) => screen?.screen_id)
    .filter((id): id is number => id != null);
}

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private screens: any[] = [];

  loadPermissions(roleData: any) {
    this.screens = getMenuScreenList(roleData);
    try {
      localStorage.setItem('screensPermissions', JSON.stringify(this.screens));
    } catch {
      // ignore storage errors
    }
  }

  private getScreen(screenId: any) {
    if (!this.screens || this.screens.length === 0) {
      try {
        const cached = localStorage.getItem('screensPermissions');
        if (cached) {
          this.screens = JSON.parse(cached) || [];
        }
      } catch {
        this.screens = this.screens || [];
      }
    }
    return this.screens.find(s => s.screen_id == screenId);
  }

  hasPermission(screenId: any, action: PermissionAction): boolean {
    const screen = this.getScreen(screenId);
    if (!screen) return false;

    return !!screen[`${action}_permission`];
  }

  hasAnyPermission(screenId: number, actions: PermissionAction[]): boolean {
    const screen = this.getScreen(screenId);
    if (!screen) return false;

    return actions.some(action => !!screen[`${action}_permission`]);
  }

}